import { FC, useContext } from 'react';
import Modal from '@components/Modal';

import { ProductContext } from '@providers/Product';

import './ProfileModal.scss';

type ProfileModalProps = {
    isOpen: boolean;
    onClose: () => void;
};

const ProfileModal: FC<ProfileModalProps> = ({ isOpen, onClose }) => {
    const { productSettings } = useContext(ProductContext);

    const firstName = localStorage.getItem('firstName');
    const lastName = localStorage.getItem('lastName');
    const email = localStorage.getItem('originalUsername');

    return (
        <Modal
            opened={isOpen}
            title="My Profile"
            onClose={onClose}
            style={{ minWidth: 400 }}
        >
            <div className="profile-modal">
                <p>
                    <b>Username:</b>
                    <br />
                    <div>{email !== "null" ? email : ''}</div>
                </p>
                <p>
                    <b>Name:</b>
                    <br />
                    <div>{firstName !== "null" ? firstName : ''}</div>
                </p>
                <p>
                    <b>Lastname:</b>
                    <br />
                    <div>{lastName !== "null" ? lastName : ''}</div>
                </p>
                <p>
                    <b>Email:</b>
                    <br />
                    <div>{email !== "null" ? email : ''}</div>
                </p>
                <hr />
                <h3>Company Information</h3>
                <p>
                    <b>Company Name:</b>
                    <br />
                    <div>{productSettings?.companyName}</div>
                </p>
                <p>
                    <b>Company Description:</b>
                    <br />
                    <div>{productSettings?.description}</div>
                </p>
                <p>
                    <b>Company Headquarters:</b>
                    <br />
                    <div>{productSettings?.headQuarters}</div>
                </p>
            </div>
        </Modal>
    );
};

export default ProfileModal;
